import { NVButton } from '@nv/basic-components'
import { Skeleton } from '@nv/components'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styles from './EventFooter.module.scss'

const EventFooter = ({ event, hasVoted, votingOpen, loadingVotingOpen }) => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const getButtonText = () => {
    if (votingOpen && (!hasVoted || event.multipleVotesEnabled)) return t('main.vote')
    return t('main.view')
  }

  return (
    <div className={styles['footer']}>
      {!loadingVotingOpen ? (
        <NVButton
          variant='primaryGrey'
          classes={{ container: styles['btn'] }}
          text={getButtonText()}
          onClick={() => navigate(`/voting/voter/event-details/${event.tiviId}`, { state: { event, hasVoted } })}
        />
      ) : (
        <Skeleton width={80} />
      )}
    </div>
  )
}

export default EventFooter
